import type { ReactNode, MouseEvent } from 'react'
import { createPortal } from 'react-dom'
import { X } from 'lucide-react'
import styles from './Modal.module.css'

type ModalVariant = 'center' | 'bottomSheet'

interface ModalProps {
  /** Вызывается при клике по overlay / крестику */
  onClose: () => void
  /** Содержимое модалки */
  children: ReactNode
  /** Вариант отображения: центрированная панель или bottom-sheet */
  variant?: ModalVariant
  /** Показывать ли кнопку-крестик в правом верхнем углу */
  showClose?: boolean
}

/**
 * Модалка с overlay. Клик по overlay закрывает модалку, клик внутри — нет.
 * @param onClose - Колбэк закрытия
 * @param children - Содержимое модалки
 * @param variant - 'center' (по центру) или 'bottomSheet' (снизу, скругл. верх)
 * @param showClose - Показывать ли крестик
 */
export const Modal = ({ onClose, children, variant = 'center', showClose = false }: ModalProps) => {
  const stop = (e: MouseEvent<HTMLDivElement>) => e.stopPropagation()

  const overlayClass = variant === 'bottomSheet' ? styles.overlayBottom : styles.overlay
  const sheetClass = variant === 'bottomSheet' ? styles.sheetBottom : styles.sheet

  return createPortal(
    <div className={overlayClass} onClick={onClose} role="presentation">
      <div className={sheetClass} onClick={stop}>
        {showClose && (
          <button
            type="button"
            className={styles.close}
            onClick={onClose}
            aria-label="Close"
          >
            <X size={24} strokeWidth={2} />
          </button>
        )}
        {children}
      </div>
    </div>,
    document.body
  )
}
